/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */

export enum CLOUD_STATUS {
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  Paused = 'Paused',
  Creating = 'Creating',
  Deleting = 'Deleting',
  Deactivating = 'Deactivating',
  InProcess = 'InProcess',
  Expired = 'Expired',
  Waiting = 'Waiting',
  Error = 'Error',
}

export const OFFLINE_STATUSES: Set<keyof typeof CLOUD_STATUS> = new Set(['Disabled']);
